import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import {profileTypeGuard} from "./shared/guard/profile-type.guard";
import {activeVersionGuard} from "./shared/guard/active-version.guard";
import {authGuard} from "./shared/guard/auth-guard";

const routes: Routes = [
  {
    path: '',
    data: {
      redirectToTouristSection: true
    },
    canActivate: [activeVersionGuard, profileTypeGuard],
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'settings',
    data: {
      ignoreAlertPosition: true
    },
    loadChildren: () => import('./settings/settings.module').then( m => m.SettingsPageModule)
  },
  {
    path: 'pharmacies',
    canActivate: [activeVersionGuard, profileTypeGuard],
    loadChildren: () => import('./pharmacy/pharmacy.module').then(m => m.PharmacyModule)
  },
  {
    path: 'houses',
    canActivate: [activeVersionGuard, profileTypeGuard],
    loadChildren: () => import('./house-ads/house-ads.module').then(m => m.HouseAdsModule)
  },
  {
    path: 'art',
    canActivate: [activeVersionGuard, profileTypeGuard],
    loadChildren: () => import('./art-section/art-routing.module').then(m => m.ArtPageRoutingModule)
  },
  {
    path: 'news',
    canActivate: [activeVersionGuard, profileTypeGuard],
    loadChildren: () => import('./news/news.module').then(m => m.NewsModule)
  },
  {
    path: 'waste',
    canActivate: [activeVersionGuard, profileTypeGuard],
    loadChildren: () => import('./waste/waste.module').then( m => m.WastePageModule)
  },
  {
    path: 'weather',
    canActivate: [activeVersionGuard, profileTypeGuard],
    loadChildren: () => import('./weather/weather.module').then( m => m.WeatherPageModule)
  },
  {
    path: 'search/:type',
    canActivate: [activeVersionGuard, profileTypeGuard],
    loadChildren: () => import('./search-page/search-page.module').then( m => m.SearchPagePageModule)
  },
  {
    path: 'discover',
    canActivate: [activeVersionGuard, profileTypeGuard],
    loadChildren: () => import('./tab3/tab3.module').then( m => m.Tab3PageModule)
  },
  {
    path: 'settings',
    canActivate: [activeVersionGuard, profileTypeGuard],
    loadChildren: () => import('./settings/settings.module').then( m => m.SettingsPageModule)
  },
  {
    path: 'places',
    canActivate: [activeVersionGuard, profileTypeGuard],
    loadChildren: () => import('./place-detail/place-detail.module').then( m => m.PlaceDetailPageModule)
  },
  {
    path: 'project',
    canActivate: [activeVersionGuard],
    loadChildren: () => import('./project-explanation/project-explanation.module').then( m => m.ProjectExplanationPageModule)
  },
  {
    path: 'privacy',
    canActivate: [],
    data: {
      ignoreAlertPosition: true
    },
    loadChildren: () => import('./privacy/privacy.module').then( m => m.PrivacyPageModule)
  },
  {
    path: 'welcome',
    canActivate: [activeVersionGuard],
    data: {
      ignoreAlertPosition: true
    },
    loadChildren: () => import('./welcome/welcome.module').then( m => m.WelcomePageModule)
  },
  {
    path: 'onboarding-preferences',
    loadChildren: () => import('./onboarding-preferences/onboarding-preferences.module').then( m => m.OnboardingPreferencesPageModule)
  },
  {
    path: 'jobs',
    canActivate: [activeVersionGuard, profileTypeGuard],
    loadChildren: () => import('./job-announcements/jobs/jobs.module').then( m => m.JobsPageModule)
  },
  {
    path: 'mail-verified',
    canActivate: [activeVersionGuard],
    loadChildren: () => import('./users/mail-verified/mail-verified.module').then( m => m.MailVerifiedPageModule)
  },
  {
    path: 'mail-confirmed/:token',
    canActivate: [activeVersionGuard],
    loadChildren: () => import('./users/mail-confirmed/mail-confirmed.module').then( m => m.MailConfirmedPageModule)
  },
  {
    path: 'pwd/reset/:token',
    canActivate: [activeVersionGuard],
    loadChildren: () => import('./users/reset-token-pwd/reset-token-pwd.module').then( m => m.ResetTokenPwdPageModule)
  },




  {
    path: 'tourist-tabs',
    canActivate: [activeVersionGuard, profileTypeGuard],
    loadChildren: () => import('./tourist-tabs/tourist-tabs.module').then( m => m.TouristTabsPageModule)
  },
  {
    path: 'events',
    canActivate: [activeVersionGuard, profileTypeGuard],
    loadChildren: () => import('./events/events.module').then( m => m.EventsPageModule)
  },
  {
    path: 'update',
    loadChildren: () => import('./version-update-forced/version-update-forced.module').then( m => m.VersionUpdateForcedPageModule)
  },
  {
    path: 'transports',
    canActivate: [activeVersionGuard, profileTypeGuard],
    loadChildren: () => import('./transports/transports.module').then( m => m.TransportsPageModule)
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadChildren: () => import('./profile/profile.module').then( m => m.ProfilePageModule)
  },
  {
    path: 'template-detail',
    canActivate: [activeVersionGuard, profileTypeGuard],
    loadChildren: () => import('./template-detail/template-detail.module').then( m => m.TemplateDetailPageModule)
  },
  {
    path: 'rubrica-list',
    canActivate: [activeVersionGuard, profileTypeGuard],
    loadChildren: () => import('./rubrica-list/rubrica-list.module').then( m => m.RubricaListPageModule)
  },
  {
    path: 'down-app',
    loadChildren: () => import('./down-app/down-app.module').then( m => m.DownAppPageModule)
  },
  {
    path: 'art',
    loadChildren: () => import('./art-section/art.module').then(m => m.ArtPageModule)
  },
  {
    path: 'corsi',
    loadChildren: () => import('./rubrica-list/corsi/corsi.module').then(m => m.CorsiPageModule)
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
